import {WorkOrderDetails} from "./WorkOrderDetails";

export interface UpdateWorkOrderParams {
	wo: WorkOrderDetails,
	updateType: WorkOrderUpdateType
}

export enum WorkOrderUpdateType {
	CustomerContact = 1,
	Schedule = 2,
	Complete = 3
}
